import {DeliveryManagerSceneType} from './deliveryManager'

export const COMMON_ROUTER_KEY = {
    personalCustomsClearancePage: 'personalCustomsClearancePage',
} as const

export const FDS_SUCCESS_SUB_PATH = 'apply'

export const FDS_CANCELED_SUB_PATH = 'cancel'

export const PAYMENT_METHODS_ROUTES = {
    MAIN: '/paymentMethods',
    DIGITAL_CONTENTS: {
        /** 디지털콘텐츠 정기결제 주문서 */
        MAIN: '/paymentMethods/digitalcontents',
        /** 등록 결과 연동 */
        RESULT: '/paymentMethods/digitalcontents/result',
        BRIDGE: {
            MAIN: '/paymentMethods/digitalcontents/bridge',
            /** FDS 결과 연동 */
            FDS_AUTH_BRIDGE: '/paymentMethods/digitalcontents/bridge/fds',
            /** 휴대폰 일반결제 인증 결과 연동 페이지 */
            MOBILE_PAYMENT_BRIDGE: '/paymentMethods/digitalcontents/bridge/mobilePayment',
            /** 주문서 Popup 에서 결과를 opener 로 전달받는 BridgePage */
            POPUP_BRIDGE: '/paymentMethods/digitalcontents/bridge/popup',
            /** FDS - ARS 인증 후 휴대폰 결제 모듈로 연결하는 bridgePage */
            ARS_MOBILE_BRIDGE: '/paymentMethods/digitalcontents/bridge/ars',
        },
    },
    PARTNERS: {
        /** 인증형 주문서 */
        MAIN: '/paymentMethods/partners',
        APPLY: `/paymentMethods/partners/${FDS_SUCCESS_SUB_PATH}`,
    },
    BRIDGE: {
        ADD_PAYMENT_METHOD: '/paymentMethods/bridge/popup',
    },
}

/**
 * 결제창 ROUTES
 */

const PAYMENT_APP_PATH = '/instantPay' as const

const PAYMENT_SERVICE = {
    // 인증형
    PARTNERS: 'partners',
    // 결제형 단건
    NAVER_FINANCIAL: 'nfPayment',
    // 결제형 자동
    NAVER_FINANCIAL_AUTO: 'nfAuto',
    // 디지털 컨텐츠 서비스
    DICON: 'dicon',
} as const

export const PAYMENT_ROUTES = {
    /** 결제형 단건 주문서 */
    NAVER_FINANCIAL: {
        MAIN: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.NAVER_FINANCIAL}`,
        CHECKOUT: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.NAVER_FINANCIAL}`,
        APPLY: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.NAVER_FINANCIAL}/${FDS_SUCCESS_SUB_PATH}`,
    },
    /** 결제형 자동 주문서 */
    NAVER_FINANCIAL_AUTO: {
        MAIN: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.NAVER_FINANCIAL_AUTO}`,
        CHECKOUT: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.NAVER_FINANCIAL_AUTO}`,
        APPLY: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.NAVER_FINANCIAL_AUTO}/${FDS_SUCCESS_SUB_PATH}`,
    },
    /** 인증형 단건 주문서 */
    PARTNERS: {
        MAIN: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.PARTNERS}`,
        CHECKOUT: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.PARTNERS}/checkout`,
        APPLY: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.PARTNERS}/${FDS_SUCCESS_SUB_PATH}`,
    },
    /** 결제 상세 */
    DETAIL: {
        MAIN: `${PAYMENT_APP_PATH}/detail`,
    },
} as const

export type LocationState = {
    fullScreenDialogId?: string

    deliveryFullScreenDialogId?: string
    shouldAuthenticationCheck?: boolean
    fullScreenIframeSrc?: {
        url: string
        restoreOnRefresh: boolean
    }
    deliveryManagerScene?: DeliveryManagerSceneType
    historyCountFromBase?: number
    sheetId?: string
}
